export { default } from './CustomModulePartnersPage'
